import { render } from "./HrCriterionForm.vue?vue&type=template&id=36da496a&scoped=true"
import script from "./HrCriterionForm.vue?vue&type=script&lang=ts"
export * from "./HrCriterionForm.vue?vue&type=script&lang=ts"

import "./HrCriterionForm.vue?vue&type=style&index=0&id=36da496a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36da496a"

export default script